// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"55":"47f01e66","126":"cf9c0834","259":"50ee73aa","410":"40a6e79d","523":"ef0f2f73","896":"bb63de53"}[chunkId] + ".chunk.css";
};